/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b6ae348b8c6810238311597a89c86d620ba854ce";
